import React from "react";
import { useFormik, FormikProvider } from "formik";
import { Button } from "primereact/button";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { forgotPasswordInitialValues } from "@constants/initialValues";
import { ForgotPasswordValidationSchema } from "@constants/validationSchema";
import { IForgotPassword } from "@constants/interfaces";
import Input from "@/components/forms/Input";
import AuthLayout from "@/layouts/AuthLayout";

export default function ForgotPassword() {
  const [loading, setLoading] = React.useState(false);

  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: forgotPasswordInitialValues,
    validationSchema: ForgotPasswordValidationSchema,
    onSubmit: (values: IForgotPassword) => {
      /*
       *
       * //TODO: Replace with password reset logic
       *
       */
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        toast.success("Password reset link sent to your email");
      }, 2000);
    },
  });

  const { handleSubmit } = formik;

  return (
    <AuthLayout>
      <div className="flex flex-column gap-4">
        <div>
          <Button
            className="text-white border-circle"
            icon="pi pi-arrow-left"
            onClick={() => navigate(-1)}
          />
        </div>

        <section>
          <h1>Forgot Password</h1>

          <p>
            Enter the email address associated with your account, and we’ll
            email you a link to reset your password.
          </p>
        </section>

        <FormikProvider value={formik}>
          <div className="flex flex-column gap-5">
            <Input
              icon="pi pi-envelope"
              label="Email"
              id="email"
              placeholder="example@company.com"
              isRequired
            />

            <Button
              loading={loading}
              label="Sign in"
              className="w-full text-white"
              disabled={!formik.isValid}
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.preventDefault();
                handleSubmit();
              }}
            />
          </div>
        </FormikProvider>
      </div>
    </AuthLayout>
  );
}
